import { forwardRef } from 'react';
import { WeaveTheme } from '@frontend/theme';

export interface ErrorFilledProps extends React.SVGProps<SVGSVGElement> {
  colors: WeaveTheme['colors'];
  primaryColor?: string;
  secondaryColor?: string;
}

const ErrorFilled = forwardRef<SVGSVGElement, ErrorFilledProps>(
  ({ colors, primaryColor, secondaryColor, ...props }, ref) => {
    return (
      <svg {...props} ref={ref} fill='none' viewBox='0 0 24 24'>
        <path
          fill={primaryColor ?? colors.critical20}
          d='M22 12.004c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10'
        ></path>
        <path
          fill={secondaryColor ?? '#912B2D'}
          fillRule='evenodd'
          d='M7.979 14.22a1.25 1.25 0 0 0 1.768 1.768l2.234-2.234 2.234 2.234a1.25 1.25 0 1 0 1.768-1.768l-2.235-2.234 2.236-2.236a1.25 1.25 0 0 0-1.767-1.768l-2.236 2.236-2.236-2.236A1.25 1.25 0 1 0 7.977 9.75l2.236 2.236L7.98 14.22'
          clipRule='evenodd'
        ></path>
      </svg>
    );
  }
);

ErrorFilled.displayName = 'ErrorFilled';

export default ErrorFilled;
